import Styled from 'styled-components';

export const ColorValue = Styled.div`
  color: ${(props) => props.mycolor};
  font-weight: ${(props) => props.myfont};
  white-space: nowrap;
`;
